// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

var jQuery = require('jquery')
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"


import Swal from 'sweetalert2'
window.Swal = Swal

//= require pace/pace

global.Rails = Rails


global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

import 'bootstrap'


var title_msg= "";
var confirm_msg= "";
var cancel_msg= "";

if(gon.locale == "ar"){
  title_msg = "هل انت متأكد؟";
  confirm_msg = "نعم, قم بالحذف";
  cancel_msg = "لا";
}else{
  title_msg = "Are you sure?";
  confirm_msg = "Yes, delete it!";
  cancel_msg = "No";
}


window.replaceQueryParam = function(param, newval, search) {
  var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
  var query = search.replace(regex, "$1").replace(/&$/, '');

  return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
}

window.goto = function(url){
  window.location = url
}


Rails.confirm = function(message, element) {
  let $element = $(element)

  // Prefer reading raw attributes (most reliable across Rails UJS + jQuery behaviors)
  let titleOverride = element && element.getAttribute && element.getAttribute('data-confirm-title')
  let confirmOverride = element && element.getAttribute && element.getAttribute('data-confirm-button')
  let cancelOverride = element && element.getAttribute && element.getAttribute('data-cancel-button')

  // Fallback to jQuery's data() in case attributes were set dynamically
  titleOverride = titleOverride || $element.data('confirmTitle')
  confirmOverride = confirmOverride || $element.data('confirmButton')
  cancelOverride = cancelOverride || $element.data('cancelButton')
  Swal.fire({
    title: titleOverride || title_msg,
    text: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: cancelOverride || cancel_msg,
    confirmButtonText: confirmOverride || confirm_msg
    }).then((result) => {
    if (result.isConfirmed) {
      let old = Rails.confirm
      Rails.confirm = function() { return true }
      $element.get(0).click();
      Rails.confirm = old;
    }
  });
  return false;
}

function initializeTpoClaimActivityReview() {
  var claimDecision = document.getElementById('tpo-claim-decision')
  var activityDecisions = document.getElementById('tpo-activity-decisions')
  var denialCode = document.getElementById('tpo-claim-denial-code')
  var denialRequirement = document.getElementById('tpo-denial-code-requirement')
  if (!claimDecision) return

  function updateActivityControls() {
    var partial = claimDecision.value === 'partially_approved'
    var denialRequired = partial || claimDecision.value === 'rejected'
    if (activityDecisions) activityDecisions.hidden = !partial
    document.querySelectorAll('.tpo-activity-review-control').forEach(function(control) {
      control.disabled = !partial
    })
    if (denialCode) {
      denialCode.required = denialRequired
      if (denialCode.options.length > 0) {
        denialCode.options[0].text = denialRequired ? denialCode.dataset.requiredLabel : denialCode.dataset.optionalLabel
      }
    }
    if (denialRequirement) denialRequirement.hidden = !denialRequired
  }

  claimDecision.addEventListener('change', updateActivityControls)
  updateActivityControls()
}

document.addEventListener('turbolinks:load', initializeTpoClaimActivityReview)

function initializeTpoAuthorizationDenialReview() {
  var decision = document.getElementById('tpo-auth-decision')
  var denialCode = document.getElementById('tpo-auth-denial-code')
  var denialRequirement = document.getElementById('tpo-auth-denial-code-requirement')
  var activityDecisions = document.getElementById('tpo-auth-activity-decisions')
  if (!decision) return

  function updateDenialControls() {
    var partial = decision.value === 'partially_approved'
    var denialRequired = partial || decision.value === 'rejected'
    if (activityDecisions) {
      if (partial) {
        activityDecisions.removeAttribute('hidden')
        activityDecisions.style.display = ''
      } else {
        activityDecisions.setAttribute('hidden', 'hidden')
        activityDecisions.style.display = 'none'
      }
    }
    document.querySelectorAll('.tpo-auth-activity-review-control').forEach(function(control) {
      control.disabled = !partial
    })
    if (denialCode) {
      denialCode.required = denialRequired
      if (denialCode.options.length > 0) {
        denialCode.options[0].text = denialRequired ? denialCode.dataset.requiredLabel : denialCode.dataset.optionalLabel
      }
      if (!denialRequired) denialCode.value = ''
    }
    if (denialRequirement) {
      if (denialRequired) {
        denialRequirement.removeAttribute('hidden')
        denialRequirement.style.display = ''
      } else {
        denialRequirement.setAttribute('hidden', 'hidden')
        denialRequirement.style.display = 'none'
      }
    }
  }

  decision.addEventListener('change', updateDenialControls)
  updateDenialControls()
}

document.addEventListener('turbolinks:load', initializeTpoAuthorizationDenialReview)

function initializeTpoClaimHistoryLink() {
  var button = document.getElementById('tpo-show-reviewed-revision')
  if (!button || button.dataset.historyLinkInitialized === 'true') return
  button.dataset.historyLinkInitialized = 'true'

  button.addEventListener('click', function(event) {
    event.preventDefault()
    var target = document.getElementById(button.dataset.target)
    if (!target) return

    target.classList.remove('is-flashing')
    void target.offsetWidth
    target.classList.add('is-flashing')
    target.scrollIntoView({ behavior: 'smooth', block: 'center' })

    window.setTimeout(function() {
      target.classList.remove('is-flashing')
    }, 2400)
  })
}

document.addEventListener('turbolinks:load', initializeTpoClaimHistoryLink)



Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "controllers"
